import script from "./UnlinkPlatformGroupsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UnlinkPlatformGroupsModal.vue?vue&type=script&setup=true&lang=js"

import "./UnlinkPlatformGroupsModal.vue?vue&type=style&index=0&id=aacaf6f4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aacaf6f4"]])

export default __exports__